import Component from '../core/Component';

export default class ChatOpener extends Component {

    constructor(element) {
        super(element);
        this.block = false;
    }

    require = async function() {
        const TimelineLite = await import('TimelineLite');
        await import('MorphSVGPlugin');
        await import('CSSPlugin');
        return TimelineLite;
    }

    prepare(TimelineLite) {
        this.chatElement = document.querySelector('[data-component="Chat"]')
        this.chat = Component.getFromElement(this.chatElement)

        this.element.addEventListener('click', event => {
            event.stopPropagation();

            if (!this.block) {
                this.block = true;

                if (!document.documentElement.classList.contains('chat-is-opened')) {
                    this.open()
                } else {
                    this.close()
                }
            }
        })

        document.addEventListener('click', ::this.close)
        document.addEventListener("keydown", (event) => {
            if (!this.block) {
                event = event || window.event;
                if (event.keyCode == 27) {
                    this.close();
                }
            }
        });
    }

    destroy() {
        //
    }

    open () {
        document.documentElement.classList.add('chat-is-opened')
        let svg = this.ref.svg;
        let background = this.ref.background;
        let backgroundPath = this.ref.backgroundPath;
        let backgroundMiddle = this.ref.backgroundMiddle;
        let backgroundPathOpened = this.ref.backgroundPathClosed;
        let backgroundPathClosed = this.ref.backgroundPathOpened;

        let open = new TimelineLite();
        open
            //.to(backgroundPath, .2, {morphSVG: backgroundMiddle})
            .to(backgroundPath, .5, {morphSVG: backgroundPathClosed})
            .to(background, .5, {
                transform: 'translate3d(-295px, -540px, 0)',
            }, 0)
            .to(svg, .5, {
                width: '360px',
                height: '511px',
            }, 0)

        setTimeout(() => {
            this.block = false;
        }, 500)

        this.chat.component.focus()
    }

    close() {
        document.documentElement.classList.remove('chat-is-opened')

        let svg = this.ref.svg;
        let background = this.ref.background;
        let backgroundPath = this.ref.backgroundPath;
        let backgroundMiddle = this.ref.backgroundMiddle;
        let backgroundPathOpened = this.ref.backgroundPathClosed;
        let backgroundPathClosed = this.ref.backgroundPathOpened;

        let close = new TimelineLite();
        close
            //.to(backgroundPath, .3, {morphSVG: backgroundMiddle})
            .to(backgroundPath, .3, {morphSVG: backgroundPathOpened})
            .to(background, .4, {
                transform: 'translate3d(0, 0, 0)',
            }, 0)
            .to(svg, .4, {
                width: '65px',
                height: '65px',
            }, 0)

        setTimeout(() => {
            this.block = false;
        }, 400)
    }

}


// WEBPACK FOOTER //
// ./components/ChatOpener.js